import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import { registrationInputMaxLength } from "app/utils/const";
import { useState } from "react";
import { IntlShape } from "react-intl";

type BuildingCityTypes = {
  handleChange: (id: string, value: string) => void;
  building: string;
  city: string;
  intl: IntlShape;
  buildingValidationError: boolean;
  cityValidationError: boolean;
};

const MESSAGES = {
  REQUIRED: "Required",
  ENTER_BUILDING: "registrations-enter-building",
  ENTER_CITY: "registrations-enter-city",
  BUILDING: "registrations-building",
  CITY: "registrations-city",
};

const BuildingCity = ({
  handleChange,
  building,
  city,
  intl,
  buildingValidationError,
  cityValidationError,
}: BuildingCityTypes) => {
  const [errorBuilding, setErrorBuilding] = useState<string>("");
  const [errorCity, setErrorCity] = useState<string>("");

  const validateBuilding = (id: string, value: string) => {
    // Ensure the building name has at least 2 characters to meet validation requirements.
    // Prevents invalid or overly short building names from being accepted.
    if (value.length < 2) {
      setErrorBuilding(
        intl.formatMessage({
          id: MESSAGES.REQUIRED,
        })
      );
    } else {
      setErrorCity("");
    }
  };

  const validateCity = (id: string, value: string) => {
    // Ensure the city name has at least 2 characters to meet validation requirements.
    // This prevents invalid or overly short city names from being accepted.
    if (value.length < 2) {
      setErrorCity(
        intl.formatMessage({
          id: MESSAGES.REQUIRED,
        })
      );
    } else {
      setErrorCity("");
    }
  };

  return (
    <>
      <div className="form-details__row form-details__single_col">
        <InputWithLabel
          label={intl.formatMessage({ id: MESSAGES.BUILDING })}
          inputId={"building"}
          value={building}
          onValueChange={handleChange}
          key={"building"}
          type={"text"}
          required={true}
          maxLength={registrationInputMaxLength.emailMaxLength}
          placeholder={intl.formatMessage({
            id: MESSAGES.ENTER_BUILDING,
          })}
          validateInput={true}
          error={errorBuilding}
          handleValidation={validateBuilding}
        />
      </div>
      <div className="form-details__row form-details__single_col">
        <InputWithLabel
          label={intl.formatMessage({
            id: MESSAGES.CITY,
          })}
          inputId={"city"}
          value={city}
          onValueChange={handleChange}
          key={"city"}
          type={"text"}
          required={true}
          maxLength={registrationInputMaxLength.emailMaxLength}
          placeholder={intl.formatMessage({
            id: MESSAGES.ENTER_CITY,
          })}
          validateInput={true}
          error={errorCity}
          handleValidation={validateCity}
        />
      </div>
    </>
  );
};

export default BuildingCity;
